var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifybyEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.54 52.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#022752;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-envelope-closed",
    "data-name": "Icon open-envelope-closed",
    className: "cls-1",
    d: "M0,0V8.82L35.27,26.45,70.54,8.82V0ZM0,17.64V52.91H70.54V17.64L35.27,35.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifybyEmail);
export default __webpack_public_path__ + "static/media/Verify by Email.11b8a1371eca9da1daebe91206c4de9a.svg";
export { ForwardRef as ReactComponent };